{
  "vehicles": "Vehicles",
  "addVehicle": "Add Vehicle",
  "add": "Add",
  "vehicleDetails": "Vehicle Details",
  "registration": "Registration",
  "make": "Make",
  "model": "Model",
  "year": "Year",
  "fuelType": {
    "bifuel": "Bi-fuel",
    "eletrico": "Electric",
    "gasoleo": "Diesel",
    "gasolina": "Gasoline",
    "hibrido": "Hybrid"
  },
  "fuelTypePlaceholder": "optional",
  "assignedDrivers": "Assigned drivers",
  "search": "Search by registration, make, or model",
  "noResults": "No results",
  "noDetails": "No details",
  "previous": "Previous",
  "next": "Next",
  "page": "Page",
  "of": "of",
  "showing": "Showing",
  "ascending": "A-Z",
  "descending": "Z-A",
  "cancel": "Cancel",
  "createVehicleError": "Failed to create vehicle. Please try again.",
  "networkError": "Network error. Please try again.",
  "registrationRequired": "Registration number is required.",
  "invalidYear": "Invalid year.",
  "fuelType.gasolina": "Gasoline",
  "fuelType.gasoleo": "Diesel",
  "fuelType.bifuel": "Bi-fuel",
  "fuelType.hibrido": "Hybrid",
  "fuelType.eletrico": "Electric",
  "vehicleInformation": "Vehicle Information",
  "assignDrivers": "Assign Drivers",
  "searchDrivers": "Search by name or email...",
  "selectAtLeastOneDriver": "Please select at least one driver",
  "errorAssigningDrivers": "Error assigning drivers",
  "selected": "selected",
  "select": "Select",
  "noDriversFound": "No drivers found matching your search",
  "noAvailableDrivers": "No available drivers to assign",
  "noAssignedDrivers": "No drivers assigned",
  "loadDriversError": "Unable to load drivers",
  "bulkActions": {
    "selected": "Selected: {{count}}",
    "selectAll": "Select All",
    "transfer": "Transfer",
    "transferVehicles": "Transfer {{count}} Vehicles",
    "transferVehiclesDescription": "Select the target company to transfer the selected vehicles to.",
    "transferResult": "Transferred {{success}} vehicle(s). {{errors}} error(s).",
    "transferError": "Error transferring vehicles: {{error}}",
    "transferLicenseErrorDrivers": "Target company has no available driver licenses to transfer related drivers.",
    "result": "Operation Result"
  },
  "transfer": {
    "alsoTransferVehicles": "Also transfer {{count}} related vehicles",
    "alsoTransferDrivers": "Also transfer {{count}} related drivers",
    "selectCompany": "Please select a target company",
    "error": "Error transferring",
    "noOtherCompanies": "You need at least one other company to transfer to.",
    "errorLoadingCompanies": "Error loading companies",
    "transferButton": "Transfer"
  },
  "common": {
    "ok": "OK",
    "cancel": "Cancel"
  }
}
